import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import styled from "styled-components";
import ContentLoadingSpinner from "components/shared/spinners/ContentLoadingSpinner";
import CallToActionButton from "components/shared/buttons/CallToActionButton";
import uuidv4 from "uuid/v4";

const LoadMoreButton = styled<any>(CallToActionButton).attrs({ className: "text-sm" })``;

const LoaderContainer = styled.div.attrs({
	className: "flex items-center justify-center w-full h-48"
})``;

export default ({ loading, onClickLoad }) => (
	<LoaderContainer>
		{!loading && <LoadMoreButton onClick={onClickLoad}> Load More </LoadMoreButton>}
		<AnimatePresence>
			{loading && (
				<motion.div
					key={uuidv4()}
					initial={{ opacity: 0 }}
					animate={{ opacity: 1 }}
					exit={{ opacity: 0 }}
				>
					<ContentLoadingSpinner />
				</motion.div>
			)}
		</AnimatePresence>
	</LoaderContainer>
);
